import { render, staticRenderFns } from "./gender.vue?vue&type=template&id=88880ee0&scoped=true&"
import script from "./gender.vue?vue&type=script&lang=ts&"
export * from "./gender.vue?vue&type=script&lang=ts&"
import style0 from "./gender.vue?vue&type=style&index=0&id=88880ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88880ee0",
  null
  
)

export default component.exports